import { Instance, types } from 'mobx-state-tree';
import {
  NewsFeedEventModel,
  NewsFeedPostModel,
  NewsFeedTelephonogramModel,
} from './models';

export {
  NewsFeedBaseModel,
  NewsFeedEventModel,
  NewsFeedPostModel,
  NewsFeedTelephonogramModel,
} from './models';

export const NewsFeedItemModel = types.union(
  {
    dispatcher: (snapshot: { type?: string }) => {
      switch (snapshot?.type) {
        case 'event':
          return NewsFeedEventModel;
        case 'telephonogram':
          return NewsFeedTelephonogramModel;
        default:
          return NewsFeedPostModel;
      }
    },
  },
  NewsFeedPostModel,
  NewsFeedEventModel,
  NewsFeedTelephonogramModel
);

export interface INewsFeedPost extends Instance<typeof NewsFeedPostModel> {}
export interface INewsFeedEvent extends Instance<typeof NewsFeedEventModel> {}
export interface INewsFeedTelephonogram extends Instance<
  typeof NewsFeedTelephonogramModel
> {}

export type INewsFeedItem =
  | INewsFeedPost
  | INewsFeedEvent
  | INewsFeedTelephonogram;

export const isPostFeed = (feed: INewsFeedItem): feed is INewsFeedPost =>
  feed.type === 'news';

export const isEventFeed = (feed: INewsFeedItem): feed is INewsFeedEvent =>
  feed.type === 'event';

export const isTelephonogramFeed = (
  feed: INewsFeedItem
): feed is INewsFeedTelephonogram => feed.type === 'telephonogram';
